import { isIpttqSessionOriginalsRef, type IpttqRecord } from '@kelilearning/psycheflow-contracts';

/** 稳定比较用：有序去重粒子 ID 串 */
export function sortedParticleIdKey(ids: Iterable<string | null | undefined>): string {
  const unique = new Set<string>();
  for (const raw of ids) {
    const id = String(raw || '').trim();
    if (id) unique.add(id);
  }
  return Array.from(unique).sort().join('|');
}

export function sessionParticleIdKey(
  session: { particles?: Array<{ particleId?: string | null }> | null } | null | undefined,
): string {
  return sortedParticleIdKey((session?.particles || []).map((entry) => entry.particleId));
}

export function ipttqReferenceParticleIdKey(
  record: Pick<IpttqRecord, 'referenceParticleIds'> | null | undefined,
): string {
  return sortedParticleIdKey(record?.referenceParticleIds || []);
}

/**
 * 品题范畴相对该浓缩结果的 referenceParticleIds 是否已漂移。
 * 平凡引用模式跟随会话，不提示；已归档不提示。
 */
export function isIpttqScopeDrifted(
  record: Pick<IpttqRecord, 'referenceParticleIds' | 'bankMode' | 'lifecycle'> | null | undefined,
  currentSessionParticleKey: string,
): boolean {
  if (!record) return false;
  if (String(record.lifecycle || '').trim() === 'archived') return false;
  if (isIpttqSessionOriginalsRef(record)) return false;
  return ipttqReferenceParticleIdKey(record) !== currentSessionParticleKey;
}

export function countDriftedIpttqRecords(
  records: Array<Pick<IpttqRecord, 'referenceParticleIds' | 'bankMode' | 'lifecycle'>> | null | undefined,
  currentSessionParticleKey: string,
): number {
  return (records || []).filter((record) => isIpttqScopeDrifted(record, currentSessionParticleKey)).length;
}

export const IPTTQ_SCOPE_DRIFT_TIP =
  '品题中的知识颗粒（原始 / 衍生 / 收敛）已变化，建议更新品题浓缩结果。';
